module.exports = __webpack_public_path__ + "media/images/1-8b9bac6d2b88639ef623e26599b5f9fb.svg";